import { Action } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/action_pb";
import { Group } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/groups_pb";

export const discreteNot = (a: Action[], b: Action[]) => {
  return a.filter((action) => b.indexOf(action) === -1);
};

export const intersection = (a: Action[], b: Action[]) => {
  return a.filter((action) => b.indexOf(action) !== -1);
};

export const union = (a: Action[], b: Action[]) => {
  return [...a, ...discreteNot(b, a)];
};

// Return A - B to get the available actions
// E.g. A, all actions - B, all assigned actions = all available actions
export const difference = (a: Action[], b: Action[]) => {
  const differenceArray = a.filter(
    ({ actionType: action1 }) =>
      !b.some(({ actionType: action2 }) => action2 === action1)
  );

  return differenceArray;
};

// Groups transfer list helpers
export const groupDiscreteNot = (a: Group[], b: Group[]) => {
  return a.filter((group) => b.indexOf(group) === -1);
};

export const groupIntersection = (a: Group[], b: Group[]) => {
  return a.filter((group) => b.indexOf(group) !== -1);
};

export const groupUnion = (a: Group[], b: Group[]) => {
  return [...a, ...groupDiscreteNot(b, a)];
};

// Return A - B to get the available groups
// E.g. A, all groups - B, all assigned groups = all available groups
export const groupDifference = (a: Group[], b: Group[]) => {
  const differenceArray = a.filter(
    ({ name: name1 }) => !b.some(({ name: name2 }) => name2 === name1)
  );

  return differenceArray;
};
